<template>
  <div class="d-flex certificate-ug2 bg-white w-100" style="width: 1056px !important; height: 816px;">
      <div class="c-left">
          <div class="card px-3 my-3 pt-2">
              <div class="card-header d-flex container-header-images pt-1 pb-0 mr-3">
                  <img src="../assets/logo-ges-black.png" class="logo-ges">
              </div>
              <div class="card-body mt-3 pt-3">
                  <h2 class="px-4 pr-0 text-uppercase mb-0 text-dark-50 title-constancia campton-bold"><strong>CONSTANCIA</strong></h2>
                  <h6 class="px-4 pr-0 text-uppercase color-ug my-0 pb-0 campton-regular text-participation"><strong>de participación</strong></h6>
                  <p class="px-4 card-text pr-0 pt-3 mb-0 campton-semibold letter-s1 font-weight-bold text-dark-50">Se otorga la presente constacia digital a:</p>
                  <div class="container-user-name pt-2">
                      <h4 class="pl-4 pr-0 my-1 title-name color-ug font-weight-bold">{{name}} {{lastname}}</h4>
                      <hr class="hr-name">
                  </div>
                  <div class="py-2 pl-4 pr-4 container-info-course">
                      <div class="borders-container">
                          <h6 class="text-dark-50 mb-1">Por su participación en el curso:</h6>
                          <h6 class="letter-s2 mb-0 pb-0 pt-1"><strong>Data Visualization and Data Storytelling</strong></h6>
                          <p class="text-info-course pr-0 text-mini pb-0 mb-0 text-dark-50 pt-1">Este curso fue impartido en modalidad virtual, con una duración de 20 horas</p>
                          <p class="text-info-course pr-0 text-mini pb-0 mb-0 text-dark-50">distribuido en 6 sesiones de clases en vivo y entrega de proyecto final grupal.</p>
                      </div>
                  </div>
                  <div class="firm d-flex justify-content-between px-4 py-2">
                      <div class="col-4 px-0 text-center">
                          <img src="../assets/MarcoZappatore_signature_transparent.png" alt="" class="signature-img">
                          <hr />
                          <h5 class="nombre mb-1 nombre text-center color-ug pt-1 ml-2">Ing. Marco Zappatore, Ph.D.</h5>
                          <h6 class="text-center mb-0 text-dark-75">Senior Researcher in Information Processing Systems</h6>
                          <h6 class="text-center mb-0 text-dark-75">University of Salento</h6>
                      </div>
                      <div class="col-5 px-0 text-center">
                          <img src="../assets/firma-byron.png" alt="" class="signature-img-h  signature-img">
                          <hr />
                          <h5 class="nombre text-center mb-1 color-ug pt-1">Ing. Byron H. Linares Ms.C.</h5>
                          <h6 class="text-center mb-0 text-dark-75">Coordinador</h6>
                          <h6 class="text-cente0r mb-0 text-dark-75">Galileo Educational System</h6>
                      </div>
                  </div>
                  <div class="dp-footer px-4 mb-0 pr-0">
                      <div class="row mb-0">
                          <div class="col-md-4">
                          </div>
                          <div class="col-md-4 text-center qr-code">
                            <p class="text-l text-dark-50 mb-1">Guatemala, {{signDate}}</p>
                            <QrcodeVueTemplate size="112" :url="verifyUrl"/>
                            <p class="text-l text-dark-50 mb-1 campton-bold" style="font-size:0.55rem; line-height: 1;"><strong>Valida aquí la autenticidad de este documento</strong></p>
                          </div>
                      </div>
                  </div>
                </div>
          </div>
          <div class="corner-image-ges">
            <img src="../assets/corner-lb2.png" alt="">
          </div>
      </div>
  </div>
</template>


<script>
import QrcodeVueTemplate from "../components/QrcodeVueTemplate.vue"
export default {
  name: "GES",
  props: {
      name: String,
      lastname: String ,
      course: String,
      signDate: String ,
      verifyUrl: String ,
      effort: String
  },
  components: {
    QrcodeVueTemplate
  }
};
</script>


<style scoped>
@font-face {
font-family: "CamptonBold";
src: local("CamptonBold"),
 url(../assets/fonts/CamptonBold.otf) format("truetype");
}
@font-face {
font-family: "CamptonBook";
src: local("CamptonBook"),
 url(../assets/fonts/CamptonBook.otf) format("truetype");
}
@font-face {
font-family: "CamptonMedium";
src: local("CamptonMedium"),
 url(../assets/fonts/CamptonMedium.otf) format("truetype");
}
@font-face {
font-family: "CamptonSemiBold";
src: local("CamptonSemiBold"),
 url(../assets/fonts/CamptonSemiBold.otf) format("truetype");
}
.signature-img {
  height: 105px;
  width: auto;
}
.certificate-ug2 > p {
  margin-bottom: 0;
}
.certificate-ug2 > p,h2,h3,h4,h5,h6 {
  font-family: 'CamptonSemiBold', sans-serif;
}
.color-ug {
  color: #af7c2b;
}
.shadow-card {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}
.card, .card .card-header {
  border-radius: 0;
  border-bottom: 0;
}
.firm h6, .firm h5 {
  font-size: 16.3px;
  font-family: 'CamptonBook', sans-serif;
}
.firm h5 {
  font-family: 'CamptonBold', sans-serif;
  font-weight: bold;
  letter-spacing: 2px;
  font-size: 1.1em;
}
.firm hr {
  margin-top: .3rem;
  margin-bottom: .3rem;
}
.card {
  width: 100%;
  border: 0;
  z-index: 12;
  background-color: transparent;
}
.card .card-header {
  background: transparent;
}
.c-left {
  width: 100%;
}
.certificate-ug2 {
  position: relative;
}
.text-mini {
  font-size: 0.79em;
}
.campton-bold {
  font-family: 'CamptonBold', sans-serif  !important;
  font-weight: bold;
}
.campton-regular {
  font-family: 'CamptonBook', sans-serif;
  font-weight: 400;
}
.campton-semibold {
  font-family: 'CamptonSemiBold', sans-serif;
  font-weight: 400;
}
.title-name {
  font-size: calc(14px + (36 - 14) * ((1000px - 500px) / (1600 - 500)));
}
.certificate-ug2 {
  background-image: url('../assets/background-dp.png');
  background-image: url('../assets/g12.png');
  background-repeat: no-repeat;
}
.letter-s1 {
  letter-spacing: 2px;
  font-size: 17px;
}
.text-participation strong {
  letter-spacing: 6px;
  font-size: 1.08em;
}
.text-l {
  font-size: 13.8px;
}
.letter-s2 strong{
  font-size: 1.57em;
}
.text-dark-50{
  /*color: rgb(53 53 53);*/
  color: #353535;
}
.text-dark-75 {
  color: #313839;
}
hr {
  border-top: 1px solid rgb(33 41 42 / 57%);
}
.container-header-images{
  direction: rtl;
}
.logo-ges {
  width: 140px;
  height: auto;
}

.hr-name {
  margin-left: 1.5em;
  margin-bottom: 0.5em;
}

.container-user-name {
  width: 75%;
}

.container-user-name .hr-name {
  margin-top: 2px;
}

.title-constancia strong{
  font-size: 1.35em;
}

.container-info-course {
  width: max-content;
}

.container-info-course .borders-container {
  /*background-image: linear-gradient(#af7c2b, #af7c2b), linear-gradient(#af7c2b, #af7c2b), linear-gradient(#af7c2b, #af7c2b), linear-gradient(#af7c2b, #af7c2b), linear-gradient(#4682b400, #4682b400);*/
  background-image: linear-gradient(#96bd0d, #96bd0d), linear-gradient(#96bd0d, #96bd0d), linear-gradient(#96bd0d, #96bd0d), linear-gradient(#96bd0d, #96bd0d), linear-gradient(#4682b400, #4682b400);
  background-image: linear-gradient(#0a71b3, #0a71b3), linear-gradient(#0a71b3, #0a71b3), linear-gradient(#0a71b3, #0a71b3), linear-gradient(#0a71b3, #0a71b3), linear-gradient(#4682b400, #4682b400);
  background-image: linear-gradient(#b0b2b3, #b0b2b3), linear-gradient(#b0b2b3, #b0b2b3), linear-gradient(#b0b2b3, #b0b2b3), linear-gradient(#b0b2b3, #b0b2b3), linear-gradient(#4682b400, #4682b400);
  background-repeat: no-repeat;
  background-size: 10px 35px, 35px 10px, 10px 35px, 35px 10px, 99% 99%;
  background-position: left top, left top, right bottom, right bottom, 4px 4px;
  padding: 20px 34px 2px 20px;
}
.dp-footer p{
font-family: 'CamptonBook', sans-serif;
}

.text-info-course {
  font-family: 'CamptonBook', sans-serif;
}

.corner-image-ges {
  position: relative;
  bottom: 13.50%;
  display: flex;
}
.corner-image-ges img {
  width: 10%;
  margin-left: -10px;
}
.qr-code {

}
</style>



// WEBPACK FOOTER //
// src/templates/GES.vue